export default class Nav {
  constructor() {
    this.submenusDisabledByNavigation = false; // Flag to track if submenus were disabled by navigation
    this.submenusDisabledAt = 0; // Timestamp when submenus were disabled
    window.navInstance = this; // Make instance globally available
    
    this.init();
  }

  // Create a controllable backdrop element to replace the problematic pseudo-element
  createNavBackdrop() {
    const menuCategories = document.querySelector('.menu__categories');
    if (menuCategories && !document.querySelector('.nav-backdrop')) {
      const backdrop = document.createElement('div');
      backdrop.className = 'nav-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      
      // Insert after the menu categories
      menuCategories.parentNode.insertBefore(backdrop, menuCategories.nextSibling);
      
      this.navBackdrop = backdrop;
    }
  }

  // Show the navigation backdrop
  showNavBackdrop() {
    if (this.navBackdrop) {
      this.navBackdrop.classList.add('visible');
      this.navBackdrop.classList.remove('nav-disabled');
    }
  }

  // Hide the navigation backdrop
  hideNavBackdrop() {
    if (this.navBackdrop) {
      this.navBackdrop.classList.remove('visible');
      this.navBackdrop.classList.add('nav-disabled');
    }
  }

  // Add a method to close the currently open submenu
  _closeCurrentSubmenu() {
    const openSubmenu = document.querySelector('.hover-menu[aria-hidden="false"], .nav__brands[aria-hidden="false"]');
    if (openSubmenu) {
      // Find the parent li and toggle button
      const parentLi = openSubmenu.closest('li.has__children');
      if (parentLi) {
        // Simulate clicking the back button or toggle to close
        const backButton = parentLi.querySelector('.menu__categories--back'); // Prefer back button if exists
        const toggleBtn = parentLi.querySelector('button.menuitem-toggle, button.submenu-toggle');

        if (backButton) {
           // Trigger click on the actual back button if available
           backButton.click();
        } else if (toggleBtn && parentLi.classList.contains('open')) {
           // Otherwise, trigger click on the toggle button to close it
           toggleBtn.click();
        } else {
           // Fallback: Manually close if no button found or state is unexpected
           openSubmenu.setAttribute('aria-hidden', 'true');
           openSubmenu.setAttribute('inert', '');
           if (openSubmenu._removeTrap) openSubmenu._removeTrap();
           parentLi.classList.remove('open');
           if (parentLi.parentNode) parentLi.parentNode.classList.remove('open');
           if (toggleBtn) {
             toggleBtn.setAttribute('aria-expanded', 'false');
             toggleBtn.focus(); // Focus toggle after closing
           }
        }
        return true; // Indicate a submenu was closed
      }
    }
    return false; // Indicate no submenu was closed
  }

  init() {
    // Create controllable backdrop element to replace pseudo-element
    this.createNavBackdrop();
    
    // ...existing code...
    let menuBtn = document.querySelectorAll("#main--nav-icon")
    let menuBtnClose = document.querySelectorAll(".menu__categories--close")
    this.mainNav = document.querySelectorAll("#main--nav")
    this.scrollPosition = 0

    // --- DEFINE HELPERS AND KEYDOWN LOGIC (COMMON) ---

    // Helper function to sort elements based on the computed 'order' style of their parent LI
    function sortByComputedOrder(a, b) {
      const parentA = a.closest('li');
      const parentB = b.closest('li');
      if (!parentA || !parentB) return 0; // Should not happen

      const orderA = parseInt(getComputedStyle(parentA).order) || 0;
      const orderB = parseInt(getComputedStyle(parentB).order) || 0;

      // If orders are the same, maintain original relative order (stable sort)
      // This requires knowing the original index, which we don't have easily here.
      // For simplicity, we'll just return 0, which might not be perfectly stable
      // but should be sufficient if 'order' values are unique.
      return orderA - orderB;
    }

    // Improved: Arrow key navigation for menu items (robust version)
    function getFocusableMenuItems(container) {
      // Only visible and enabled items
      return Array.from(container.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'))
        .filter(el => !el.disabled && el.offsetParent !== null);
    }
    // Update: ArrowRight should open submenu for menuitem-toggle
    function handleMenuKeydown(e) {
      const target = e.target;
      const mainCategoriesContainer = target.closest('.menu__categories');
      const isDesktop = window.matchMedia("screen and (min-width: 65rem)").matches;

      // Check if focus is on a top-level item within the main categories list
      const isTopLevelItem = mainCategoriesContainer && target.matches('.menu__categories > li > a, .menu__categories > li > button.menuitem-toggle, .menu__categories > li > button.submenu-toggle');

      // --- Roving Tabindex for Top-Level Items (Arrows/Tab) ---
      if (isTopLevelItem && (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Tab')) {
        const parentLi = target.closest('li');
        const submenu = parentLi ? parentLi.querySelector('.hover-menu, .nav__brands') : null;
        const isSubmenuOpen = submenu && submenu.getAttribute('aria-hidden') === 'false';
        const isToggleButton = target.matches('button.menuitem-toggle, button.submenu-toggle');

        // --- Desktop Tab: Enter/Exit Submenu ---
        if (isDesktop && isToggleButton && isSubmenuOpen && e.key === 'Tab') {
          if (!e.shiftKey) { // Tab moves INTO submenu
            e.preventDefault();
            focusFirstMenuItem(submenu);
            return; // Handled
          } else { // Shift+Tab moves to PREVIOUS top-level item (roving tabindex)
            // Let the roving tabindex logic below handle this
          }
        }

        // --- Roving Tabindex Logic (Arrows or Tab when submenu closed/not applicable) ---
        const items = Array.from(
          mainCategoriesContainer.querySelectorAll('.menu__categories > li > a, .menu__categories > li > button.menuitem-toggle, .menu__categories > li > button.submenu-toggle')
        ).filter(el => el.offsetParent !== null);
        items.sort(sortByComputedOrder);
        let currentIdx = items.indexOf(target);
        if (currentIdx === -1) return;

        // <<< MODIFIED: Desktop Tab Out Logic >>>
        if (isDesktop && e.key === 'Tab') {
          if (!e.shiftKey && currentIdx === items.length - 1) {
            // Tab on last item on desktop: Allow default behavior (tab out)
            return;
          } else if (e.shiftKey && currentIdx === 0) {
            // Shift+Tab on first item on desktop: Allow default behavior (tab out)
            return;
          }
        }
        // <<< END: Desktop Tab Out Logic >>>

        // Prevent default scroll AND default Tab behavior (if not tabbing out on desktop)
        e.preventDefault();

        let nextIdx;
        if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey)) {
          nextIdx = (currentIdx + 1) % items.length;
        } else { // ArrowUp or Shift+Tab
          nextIdx = (currentIdx - 1 + items.length) % items.length;
        }
        const nextItem = items[nextIdx];
        if (nextItem) {
          target.tabIndex = -1;
          nextItem.tabIndex = 0;
          nextItem.focus();
        }
        return; // Handled
      }

      // --- Submenu Navigation (Arrows/Escape/Tab) ---
      const container = target.closest('.hover-menu:not([inert]), .nav__brands:not([inert])');
      if (container) {
        const items = getFocusableMenuItems(container);
        const idx = items.indexOf(target);
        if (idx === -1) return;

        if (e.key === 'ArrowDown') {
          nextIdx = (idx + 1) % items.length;
          items[nextIdx].focus();
          e.preventDefault();
        } else if (e.key === 'ArrowUp') {
          nextIdx = (idx - 1 + items.length) % items.length;
          items[nextIdx].focus();
          e.preventDefault();
        } else if (e.key === 'ArrowLeft' || e.key === 'Escape') {
          const parentLi = target.closest('li.has__children');
          if (parentLi && parentLi.classList.contains('open')) {
            const toggleBtn = parentLi.querySelector('button.menuitem-toggle, button.submenu-toggle');
            const backBtn = container.querySelector('.menu__categories--back');
            if (backBtn && !isDesktop) { // Use back button only on mobile
              backBtn.click();
            } else if (toggleBtn) {
              // Close submenu and focus toggle (desktop Escape/ArrowLeft or mobile fallback)
              safeHideSubmenu(container, toggleBtn);
              toggleBtn.setAttribute('aria-expanded', 'false');
              parentLi.classList.remove('open');
              if (parentLi.parentNode) parentLi.parentNode.classList.remove('open');
              toggleBtn.focus();
            }
            e.preventDefault();
          }
        } else if (isDesktop && e.key === 'Tab') {
          const parentLi = container.closest('li.has__children');
          const toggleBtn = parentLi ? parentLi.querySelector('button.menuitem-toggle, button.submenu-toggle') : null;

          if (!e.shiftKey && idx === items.length - 1) { // Tab on LAST item -> next top-level
            e.preventDefault();
            safeHideSubmenu(container, toggleBtn); // Close current submenu
            // Find next top-level item using roving tabindex logic
            const topLevelItems = Array.from(
              mainCategoriesContainer.querySelectorAll('.menu__categories > li > a, .menu__categories > li > button.menuitem-toggle, .menu__categories > li > button.submenu-toggle')
            ).filter(el => el.offsetParent !== null);
            topLevelItems.sort(sortByComputedOrder);
            let currentTopIdx = topLevelItems.indexOf(toggleBtn);
            if (currentTopIdx !== -1) {
              let nextTopIdx = (currentTopIdx + 1) % topLevelItems.length;
              if (toggleBtn) toggleBtn.tabIndex = -1; // Update roving state
              topLevelItems[nextTopIdx].tabIndex = 0;
              topLevelItems[nextTopIdx].focus();
            }
          } else if (e.shiftKey && idx === 0) { // Shift+Tab on FIRST item -> parent toggle
            e.preventDefault();
            safeHideSubmenu(container, toggleBtn); // Close current submenu
            if (toggleBtn) {
              toggleBtn.focus();
            }
          }
          // Otherwise, allow default Tab/Shift+Tab within submenu
        }
        // <<< NOTE: No return here, allow fallthrough for non-desktop Tab >>>
        // <<< REMOVED return; // Handled >>>
      }

      // --- Mobile Submenu Focus Trap (Only if not desktop and inside submenu) ---
      if (!isDesktop && container && e.key === 'Tab') {
          const focusable = getFocusableMenuItems(container);
          if (focusable.length > 0) {
              const first = focusable[0];
              const last = focusable[focusable.length - 1];
              if (e.shiftKey) {
                  if (document.activeElement === first) {
                      last.focus();
                      e.preventDefault();
                  }
              } else {
                  if (document.activeElement === last) {
                      first.focus();
                      e.preventDefault();
                  }
              }
          }
          return; // Mobile tab handled
      }

      // --- Top-Level Activation (Enter/Space/ArrowRight) ---
      if (isTopLevelItem) {
        if (e.key === 'ArrowRight' || e.key === 'Enter' || e.key === ' ') {
          if (target.matches('button.menuitem-toggle, button.submenu-toggle')) {
            e.preventDefault();
            // Simulate click to trigger existing open/close logic (mobile/desktop)
            target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));

            // If opening, ensure focus moves correctly (might need slight delay)
            const parentLi = target.closest('li');
            const submenu = parentLi ? parentLi.querySelector('.hover-menu, .nav__brands') : null;
            // Check if it *will* be open after the click simulation
            const willBeOpen = !parentLi.classList.contains('open'); // Click toggles it
            if (willBeOpen && submenu) {
              setTimeout(() => {
                ensureSubmenuVisible(submenu);
                focusFirstMenuItem(submenu);
              }, 0);
            }
          } else if (target.matches('a') && (e.key === 'Enter' || e.key === ' ')) {
            // Allow default Enter/Space behavior for links (navigation)
          }
        }
      }
    }

    // Utility: set menu visibility and focusability
    function setMenuVisibility(menu, visible) {
      if (!menu) return;
      if (visible) {
        menu.removeAttribute('inert');
        menu.setAttribute('aria-hidden', 'false');
        setSubmenuAndCategoryItemsInert(menu, false);
      } else {
        menu.setAttribute('inert', '');
        menu.setAttribute('aria-hidden', 'true');
        setSubmenuAndCategoryItemsInert(menu, true);
      }
    }

    // Utility: set inert/aria-hidden on all submenus except the one being opened
    function setExclusiveSubmenuVisibility(openSubmenu) {
      const allSubmenus = document.querySelectorAll('.hover-menu, .nav__brands');
      allSubmenus.forEach((submenu) => {
        if (submenu === openSubmenu) {
          submenu.removeAttribute('inert');
          submenu.setAttribute('aria-hidden', 'false');
        } else {
          submenu.setAttribute('inert', '');
          submenu.setAttribute('aria-hidden', 'true');
        }
      });
    }

    // Utility: get first real menu item (not back button)
    function getFirstMenuItem(submenu) {
      if (!submenu) return null;
      // Find all focusable elements, but skip any with class 'menu__categories--back'
      return Array.from(submenu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'))
        .find(el => !el.classList.contains('menu__categories--back') && el.offsetParent !== null && !el.disabled);
    }

    // Utility: focus first real menu item in submenu (with logging)
    function focusFirstMenuItem(submenu) {
      if (!submenu) {
        return;
      }
      const firstLink = getFirstMenuItem(submenu);
      if (firstLink) {
        firstLink.focus();
      }
    }

    // Utility: ensure submenu is visible and focusable before focusing
    function ensureSubmenuVisible(submenu) {
      if (!submenu) return;
      submenu.removeAttribute('inert');
      submenu.setAttribute('aria-hidden', 'false');
    }

    // Utility: set inert on all .global-category-items inside a submenu
    function setGlobalCategoryItemsInert(submenu, inert) {
      if (!submenu) return;
      submenu.querySelectorAll('.global-category-items').forEach(ul => {
        if (inert) {
          ul.setAttribute('inert', '');
        } else {
          ul.removeAttribute('inert');
        }
      });
    }

    // Utility: set inert on submenu and all .global-category-items inside
    function setSubmenuAndCategoryItemsInert(submenu, inert) {
      if (!submenu) return;
      if (inert) {
        submenu.setAttribute('inert', '');
      } else {
        submenu.removeAttribute('inert');
      }
      submenu.querySelectorAll('.global-category-items').forEach(ul => {
        if (inert) {
          ul.setAttribute('inert', '');
        } else {
          ul.removeAttribute('inert');
        }
      });
    }

    // Update: Before setting aria-hidden=true, move focus out of submenu if needed
    function safeHideSubmenu(submenu, btn) {
      // Move focus back to the toggle button if focus is inside submenu
      if (submenu.contains(document.activeElement) && btn) {
        btn.focus();
      }
      submenu.setAttribute('aria-hidden', 'true');
      setSubmenuAndCategoryItemsInert(submenu, true);
    }

    // <<< START: Roving Tabindex Initialization Function (COMMON) >>>
    // Function to set initial roving tabindex state for top-level items
    function initializeRovingTabindex() {
      const mainNavContainer = document.querySelector('#main--nav');
      if (!mainNavContainer) return;

      // Select only top-level interactive items (links or toggle buttons)
      const topLevelItems = Array.from(
        mainNavContainer.querySelectorAll('.menu__categories > li > a, .menu__categories > li > button.menuitem-toggle, .menu__categories > li > button.submenu-toggle')
      ).filter(el => el.offsetParent !== null); // Only consider visible items

      if (topLevelItems.length === 0) return;

      // <<< MODIFIED: Sort items based on computed order style >>>
      topLevelItems.sort(sortByComputedOrder);

      // Set tabindex=-1 on all items initially
      topLevelItems.forEach(item => item.tabIndex = -1);

      // Set tabindex=0 on the first visually ordered item
      if (topLevelItems[0]) {
        topLevelItems[0].tabIndex = 0;
      }
    }
    // <<< END: Roving Tabindex Initialization Function >>>

    // --- ATTACH COMMON LISTENERS ---

    // Attach keydown handler using event delegation (APPLIES TO BOTH MOBILE & DESKTOP)
    const mainNavContainer = document.querySelector('#main--nav');
    if (mainNavContainer) {
      mainNavContainer.addEventListener('keydown', handleMenuKeydown);

      // Add focusin listener for scrollIntoView (primarily for mobile submenus)
      mainNavContainer.addEventListener('focusin', (e) => {
        const target = e.target;
        // Check if the focused element is inside an open submenu
        const openSubmenu = target.closest('.hover-menu:not([inert]), .nav__brands:not([inert])');
        // Check if the focused element is actually a focusable item
        const isFocusableItem = target.matches('a, button, [tabindex]:not([tabindex="-1"])');

        if (openSubmenu && isFocusableItem) {
          // Scroll the focused item into the nearest visible area of the scroll container
          // Use a slight delay to ensure rendering is complete after focus shift
          requestAnimationFrame(() => {
            target.scrollIntoView({ block: 'nearest' });
          });
        }
      });
    }

    // Run Roving Tabindex Initialization after a short delay (APPLIES TO BOTH)
    setTimeout(initializeRovingTabindex, 150); // Adjust delay if needed

    // --- VIEWPORT-SPECIFIC LOGIC ---

    if (window.matchMedia("screen and (min-width: 65rem)").matches) {
      // --- DESKTOP LOGIC ---
      // Desktop-specific: click handler for .menuitem-toggle.navigate
      document.querySelectorAll('.menuitem-toggle.navigate').forEach((btn) => {
        // Remove previous click listeners to avoid duplicates if init runs multiple times
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);

        // Utility to force-hide all submenus (overrides CSS hover while navigating)
        function forceHideAllSubmenus() {
          document.querySelectorAll('.hover-menu, .nav__brands').forEach(submenu => {
            submenu.style.setProperty('display', 'none', 'important');
          });
        }

        newBtn.addEventListener('click', function(e) {
          // Only handle mouse clicks (not keyboard)
          if (e.pointerType === 'mouse' || e.pointerType === '' || e.type === 'click') {
            const href = newBtn.getAttribute('data-href');
            if (href) {

              // Check for Ctrl + Click (or Cmd + Click on Mac)
              if (e.ctrlKey || e.metaKey) {
                // Ctrl + Click: Open in new tab
                window.open(href, '_blank');

                // Close submenus but don't do AJAX navigation
                const backdrop = document.querySelector('.backdrop');
                if (backdrop) {
                  backdrop.classList.remove('active');
                }
                document.body.classList.remove('activeNav');

                // Hide all submenus
                forceHideAllSubmenus();

                e.preventDefault();
                e.stopPropagation();
                return;
              }

              // Normal click: Allow AJAX to handle navigation
              // window.location.href = href; // Allow AJAX to handle navigation

              // Ensure submenu closes before navigation so the user sees feedback
              forceHideAllSubmenus();
            }
            // Prevent opening submenu on mouse click for desktop
            e.preventDefault();
            e.stopPropagation();
          }
          // Keyboard clicks (Enter/Space) are handled by handleMenuKeydown
        });
        // Add keydown for Ctrl+Enter/Space navigation (consistent with mobile)
        newBtn.addEventListener('keydown', (e) => {
          if ((e.key === 'Enter' || e.key === ' ') && e.ctrlKey) {
            const href = newBtn.getAttribute('data-href');
            if (href) {
              // window.location.href = href; // Allow AJAX to handle navigation
            }
          }
        });
      });

      // Desktop Hover/Focus Handling
      // CSS handles hover - JavaScript hover system disabled for pure CSS solution
      /*
      document.querySelectorAll('#main--nav .menu__categories > li.has__children').forEach(li => {
        const toggleBtn = li.querySelector('button.menuitem-toggle, button.submenu-toggle');
        const submenu = li.querySelector('.hover-menu, .nav__brands');
        if (!toggleBtn || !submenu) return;

        let closeTimeout; // Timeout to allow moving cursor into submenu

        li.addEventListener('mouseenter', () => {
          clearTimeout(closeTimeout);
          
          // Remove nav-hidden and inert from ALL submenus to allow CSS hover to work
          document.querySelectorAll('.hover-menu, .nav__brands').forEach(submenu => {
            submenu.classList.remove('nav-hidden');
            submenu.removeAttribute('inert');
            
            // Hide any stray spinners in submenus
            const spinners = submenu.querySelectorAll('.spinner');
            spinners.forEach(spinner => spinner.style.display = 'none');
          });
          
          // Close others
          document.querySelectorAll('#main--nav .menu__categories > li.has__children.open').forEach(otherLi => {
            if (otherLi !== li) {
              const otherToggle = otherLi.querySelector('button.menuitem-toggle, button.submenu-toggle');
              const otherSubmenu = otherLi.querySelector('.hover-menu, .nav__brands');
              if (otherToggle && otherSubmenu) {
                otherLi.classList.remove('open');
                otherToggle.setAttribute('aria-expanded', 'false');
                safeHideSubmenu(otherSubmenu, otherToggle);
              }
            }
          });
          // Open this one
          if (!li.classList.contains('open')) {
            li.classList.add('open');
            toggleBtn.setAttribute('aria-expanded', 'true');
            setMenuVisibility(submenu, true);
          }
        });

        li.addEventListener('mouseleave', () => {
          closeTimeout = setTimeout(() => {
            // Only close if focus is not within the submenu
            if (!li.contains(document.activeElement)) {
              li.classList.remove('open');
              toggleBtn.setAttribute('aria-expanded', 'false');
              safeHideSubmenu(submenu, toggleBtn);
            }
          }, 100); // Small delay
        });

        // Keep open if focus moves into submenu
        submenu.addEventListener('focusin', () => {
          clearTimeout(closeTimeout);
        });

        // Close if focus moves out of the entire li (toggle + submenu)
        li.addEventListener('focusout', (e) => {
          // Check if the new focus target is outside the li
          if (!li.contains(e.relatedTarget)) {
             clearTimeout(closeTimeout); // Prevent mouseleave timeout conflict
             closeTimeout = setTimeout(() => { // Use timeout to handle focus moving between items within li
                if (!li.contains(document.activeElement)) {
                    li.classList.remove('open');
                    toggleBtn.setAttribute('aria-expanded', 'false');
                    safeHideSubmenu(submenu, toggleBtn);
                }
             }, 10);
          }
        });
      });
      */

      // Setup handlers for desktop menu interaction
      // Main navigation click handling is done via event delegation above

      // CSS handles hover - no JavaScript hover system needed for desktop
      // this.setupDesktopHoverLogic(); // Disabled - using pure CSS solution

    } else {
      // --- MOBILE LOGIC ---
      // ...existing code for mobile only...
      for (var i = 0; i < menuBtn.length; ++i) {
          menuBtn[i].addEventListener("click", () => {
              this.showMainNav(this)
          })
      }
      for (var i = 0; i < menuBtnClose.length; ++i) {
          const currentBtn = menuBtnClose[i];
          const newBtn = currentBtn.cloneNode(true);
          currentBtn.parentNode.replaceChild(newBtn, currentBtn);
          newBtn.addEventListener("click", () => {
              const submenuClosed = this._closeCurrentSubmenu();
              if (!submenuClosed) {
                  this.hideMainNav(this);
              }
          })
      }
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          document.querySelector("header").addEventListener("click", (event) => {
              if (!event.target.closest("#nav-wrapper, #main--nav-icon")) {
                  this.hideMainNav(this)
              }
          }, false)
      }
      // ...rest of mobile logic...

      /* toggle level 1*/
      const navItemsLink = document.querySelectorAll(".menu__categories > li.has__children > a")
      const navItemsBack = document.querySelectorAll(".menu__categories--back")
      // Add: chevron submenu toggle buttons
      const navItemsChevron = document.querySelectorAll(".menu__categories > li.has__children > button.submenu-toggle");

      this.ScrolltoTop = document.querySelector(".menu__categories--headline")

      navItemsLink.forEach( (listItem) => {
          listItem.classList.remove('navigate')
          listItem.addEventListener("click", (e) => {
              this.setActiveLink(e, this)
          }
          )
      }
      )

      navItemsBack.forEach( (listItem) => {
          listItem.addEventListener("click", (e) => {
              this.setActiveBack(e, this)
          }
          )
      }
      )

      // Add: chevron button event listeners for submenu toggle
      navItemsChevron.forEach((chevronBtn) => {
        // Remove previous listeners first
        const newChevronBtn = chevronBtn.cloneNode(true);
        chevronBtn.parentNode.replaceChild(newChevronBtn, chevronBtn);

        newChevronBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const parent = newChevronBtn.parentNode;
          const expanded = parent.classList.toggle("open");
          parent.parentNode.classList.toggle("open");
          newChevronBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
          this.ScrolltoTop.scrollIntoView();

          // Focus management for accessibility
          if (expanded) {
            const submenu = parent.querySelector('.hover-menu, .nav__brands');
            if (submenu) {
              setExclusiveSubmenuVisibility(submenu); // Ensure only this one is visible
              setSubmenuAndCategoryItemsInert(submenu, false); // Make submenu and links interactive
              ensureSubmenuVisible(submenu); // Ensure submenu is visible before focus
              focusFirstMenuItem(submenu); // Always focus first real menu item
            }
          } else {
            // Return focus to the toggle button
            newChevronBtn.focus();
            const submenu = parent.querySelector('.hover-menu, .nav__brands');
            setExclusiveSubmenuVisibility(null); // Hide all submenus
            setSubmenuAndCategoryItemsInert(submenu, true); // Make submenu and links inert again
          }
        });
      });
      
      // Setup handlers for mobile menu interaction
      // Main navigation click handling is done via event delegation above

      // Remove all previous click handlers to avoid duplicates
      document.querySelectorAll('.menuitem-toggle.navigate').forEach((btn) => {
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
      });

      // Attach a single click handler per button (MOBILE)
      document.querySelectorAll('.menuitem-toggle.navigate').forEach((btn) => {
        btn.classList.remove('navigate'); // Prevent Ajaxify from hijacking clicks
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const parent = btn.parentNode;
          const submenu = parent.querySelector('.hover-menu, .nav__brands');
          const isOpen = parent.classList.contains('open');

          // Close all other submenus first
          document.querySelectorAll('.menuitem-toggle.navigate, .submenu-toggle').forEach(otherBtn => {
            if (otherBtn !== btn) {
              const otherParent = otherBtn.closest('li.has__children'); // Use closest li
              if (otherParent && otherParent.classList.contains('open')) {
                 const otherSubmenu = otherParent.querySelector('.hover-menu, .nav__brands');
                 otherParent.classList.remove('open');
                 if (otherParent.parentNode) otherParent.parentNode.classList.remove('open');
                 otherBtn.setAttribute('aria-expanded', 'false');
                 if (otherSubmenu) {
                   setSubmenuAndCategoryItemsInert(otherSubmenu, true); // Make inert
                 }
              }
            }
          });
          // Hide all submenus visually/semantically before potentially opening one
          setExclusiveSubmenuVisibility(null);

          if (!isOpen && submenu) { // Open this submenu
            parent.classList.add('open');
            if (parent.parentNode) parent.parentNode.classList.add('open');
            btn.setAttribute('aria-expanded', 'true');
            setExclusiveSubmenuVisibility(submenu); // Show only this submenu
            setSubmenuAndCategoryItemsInert(submenu, false); // Make submenu and links interactive
            ensureSubmenuVisible(submenu); // Ensure submenu is visible before focus
            focusFirstMenuItem(submenu); // Always focus first real menu item
          } else { // Close this submenu (if it was open)
            parent.classList.remove('open');
            if (parent.parentNode) parent.parentNode.classList.remove('open');
            btn.setAttribute('aria-expanded', 'false');
            // setExclusiveSubmenuVisibility(null); // Already called above
            setSubmenuAndCategoryItemsInert(submenu, true); // Make submenu and links inert again
            btn.focus(); // Return focus to the toggle button
          }
        });
        btn.addEventListener('keydown', (e) => {
          if ((e.key === 'Enter' || e.key === ' ') && e.ctrlKey) {
            const href = btn.getAttribute('data-href');
            if (href) {
              // Use ajaxify navigation instead of direct location change
              if (window.ajaxify && window.ajaxify.navigatePage) {
                window.ajaxify.navigatePage(href, 'list');
              } else {
                window.location.href = href;
              }
            }
          }
        });
      });

      // Remove redundant/conflicting handlers below this point as they are covered above or by handleMenuKeydown
      // ... (Remove the duplicated .menuitem-toggle.navigate handlers that follow) ...

    } // End Mobile Logic

    // --- COMMON LISTENERS (Continued) ---

    // Spinner logic for navigation (event delegation, with dynamic relative class)
    const navWrapper = document.getElementById('nav-wrapper') || document.querySelector('#main--nav');
    if (navWrapper) {
      navWrapper.addEventListener('click', function(e) {
        const navEl = e.target && e.target.closest ? e.target.closest('.navigate') : null;
        if (navEl) {
          // Add relative class only if not present
          if (!navEl.classList.contains('relative')) {
            navEl.classList.add('relative');
            navEl.dataset.spinnerRelative = '1';
          }
          let spinner = navEl.querySelector('.spinner');
          if (!spinner) {
            spinner = document.createElement('span');
            spinner.className = 'spinner';
            spinner.setAttribute('aria-hidden', 'true'); // <<< Add aria-hidden="true"
            navEl.appendChild(spinner);
          }
          spinner.style.display = 'inline-block';
          const globalSpinner = document.querySelector('.listspinner');
          if (globalSpinner) globalSpinner.style.display = 'block';
        }
      });
    }
    // Hide spinners and remove relative class on navigation complete (page load or AJAX events)
    function hideAllNavSpinners() {
      document.querySelectorAll('.navigate').forEach(navEl => {
        const spinner = navEl.querySelector('.spinner');
        if (spinner) spinner.style.display = 'none';
        if (navEl.dataset.spinnerRelative === '1') {
          navEl.classList.remove('relative');
          delete navEl.dataset.spinnerRelative;
        }
      });
      const globalSpinner = document.querySelector('.listspinner');
      if (globalSpinner) globalSpinner.style.display = 'none';

      // Don't reset the submenu disabled flag here - let it reset naturally via timeout or hover

      // Remove forced hidden state from submenus after navigation completes
      document.querySelectorAll('.hover-menu, .nav__brands').forEach(submenu => {
        submenu.style.removeProperty('display');
      });
    }
    window.addEventListener('plp_ajax_loaded', hideAllNavSpinners);
    window.addEventListener('pdp_ajax_loaded', hideAllNavSpinners);

    // Add event delegation for main navigation item clicks (capture phase to intercept before other handlers)
    document.addEventListener('click', (e) => {
      // Check if the clicked element is a main navigation item with submenu
      const mainNavItem = e.target.closest('.menu__categories > li.has__children > a, .menu__categories > li.has__children > button.menuitem-toggle, .menu__categories > li.has__children > button.submenu-toggle');
      if (mainNavItem) {
        const isDesktop = window.matchMedia("screen and (min-width: 65rem)").matches;
        
        // Only handle on desktop - hide submenus when clicking main nav items
        if (isDesktop) {
          // Set flag to prevent hover from re-enabling submenus
          this.submenusDisabledByNavigation = true;
          this.submenusDisabledAt = Date.now();
          
          // Hide backdrop and submenus immediately
          const backdrop = document.querySelector('.backdrop');
          if (backdrop) {
            backdrop.classList.remove('active');
          }
          document.body.classList.remove('activeNav', 'modal_active');
          
          // Add specific class to navigation container for higher specificity
          const navContainer = document.querySelector('#main--nav');
          if (navContainer) {
            navContainer.classList.add('nav-disabled-by-click');
          }
          
          // Hide all submenu containers 
          const submenus = document.querySelectorAll('.hover-menu, .nav__brands');
          submenus.forEach(submenu => {
            submenu.setAttribute('inert', '');
            submenu.setAttribute('tabindex', '-1');
            submenu.classList.remove('d-flex', 'show-md', 'flex-colum-xs','flex-column-sm','flex-row-md');
            submenu.classList.add('nav-hidden');
            // Force hide with inline style to override any CSS hover rules
            submenu.style.setProperty('display', 'none', 'important');
            submenu.style.setProperty('visibility', 'hidden', 'important');
            submenu.style.setProperty('opacity', '0', 'important');
            
            // Add inert back to all .global-category-items inside the submenu
            const globalCategoryItems = submenu.querySelectorAll('.global-category-items');
            globalCategoryItems.forEach(item => item.setAttribute('inert', ''));
          });
          
          // For buttons, let them continue their normal toggle behavior
          // For links, let the navigation proceed normally
        }
      }
    }, true); // Use capture phase to run before other handlers
    document.addEventListener('mouseenter', (e) => {
      const menuItem = e.target && e.target.closest ? e.target.closest('#main--nav .menu__categories > li.has__children') : null;
      if (menuItem) {
        // Check if enough time has passed since submenus were disabled (e.g., user navigated and now wants to browse again)
        const timeSinceDisabled = Date.now() - (this.submenusDisabledAt || 0);
        const isDesktop = window.matchMedia("screen and (min-width: 65rem)").matches;
        
        // Only allow hover if submenus are NOT disabled by navigation
        if (!this.submenusDisabledByNavigation) {
          // Normal hover behavior - remove nav-hidden class and clear blocking inline styles
          document.querySelectorAll('.hover-menu, .nav__brands').forEach(submenu => {
            submenu.classList.remove('nav-hidden');
            submenu.removeAttribute('inert');
            
            // CRITICAL: Remove any blocking inline styles that prevent hover behavior
            submenu.style.removeProperty('display');
            submenu.style.removeProperty('visibility');
            submenu.style.removeProperty('opacity');
          });
        }
      }
    }, true); // Use capture phase to ensure it fires before other handlers
    
    // Reset the flag when user leaves the entire navigation area
    document.addEventListener('mouseleave', (e) => {
      const navArea = e.target && e.target.closest ? e.target.closest('#main--nav') : null;
      if (navArea && this.submenusDisabledByNavigation) {
        // Reset the flag when user leaves the navigation
        this.submenusDisabledByNavigation = false;
        
        // Remove class from navigation container
        const navContainer = document.querySelector('#main--nav');
        if (navContainer) {
          navContainer.classList.remove('nav-disabled-by-click');
        }
      }
    }, true);

    // Escape in submenu: act as click on .menu__categories--back, else close main menu (single listener, no conflicts)
    document.removeEventListener('keydown', window._navEscapeHandler, true); // Remove any previous
    window._navEscapeHandler = function(e) {
      if (e.key === 'Escape') {
        // Find the innermost open submenu
        const openSubmenus = Array.from(document.querySelectorAll('.hover-menu[aria-hidden="false"], .nav__brands[aria-hidden="false"]'));
        if (openSubmenus.length > 0) {
          // Get the last (innermost) open submenu
          const openSubmenu = openSubmenus[openSubmenus.length - 1];
          // Find the .menu__categories--back button inside this submenu
          const backBtn = openSubmenu.querySelector('.menu__categories--back');
          if (backBtn) {
            backBtn.click();
            e.preventDefault();
            return;
          }
        }
        // If no submenu is open, close the main menu as before
        const mainNav = document.querySelectorAll('#main--nav');
        let menuOpen = false;
        mainNav.forEach(nav => {
          if (nav.classList.contains('active')) menuOpen = true;
        });
        if (menuOpen) {
          // Only close the menu overlay, do not touch the hamburger or header
          mainNav.forEach(nav => nav.classList.remove('active'));
          document.body.classList.remove('modal_active');
          document.body.style.removeProperty("overflow");
          document.body.style.removeProperty("position");
          document.body.style.removeProperty("top");
          // Remove backdrop
          const backdrop = document.querySelector('.backdrop');
          if (backdrop) backdrop.classList.remove('active');
          // Focus menu button
          const menuBtn = document.querySelector('#main--nav-icon');
          if (menuBtn) menuBtn.focus();
        }
      }
    };
    document.addEventListener('keydown', window._navEscapeHandler, true);

    // <<< START: Roving Tabindex Initialization >>>
    // Function to set initial roving tabindex state for top-level items
    function initializeRovingTabindex() {
      const mainNavContainer = document.querySelector('#main--nav');
      if (!mainNavContainer) return;

      // Select only top-level interactive items (links or toggle buttons)
      const topLevelItems = Array.from(
        mainNavContainer.querySelectorAll('.menu__categories > li > a, .menu__categories > li > button.menuitem-toggle, .menu__categories > li > button.submenu-toggle')
      ).filter(el => el.offsetParent !== null); // Only consider visible items

      if (topLevelItems.length === 0) return;

      // Sort items based on visual order (offsetTop is a good proxy)
      topLevelItems.sort((a, b) => a.offsetTop - b.offsetTop);

      // Set tabindex=-1 on all items initially
      topLevelItems.forEach(item => item.tabIndex = -1);

      // Set tabindex=0 on the first visually ordered item
      if (topLevelItems[0]) {
        topLevelItems[0].tabIndex = 0;

      }
    }

    // Run after a short delay to allow rendering
    setTimeout(initializeRovingTabindex, 150); // Adjust delay if needed
    // <<< END: Roving Tabindex Initialization >>>

    // Desktop-specific: click handler for .menuitem-toggle.navigate
    if (window.matchMedia("screen and (min-width: 65rem)").matches) {
      document.querySelectorAll('.menuitem-toggle.navigate').forEach((btn) => {
        btn.addEventListener('click', function(e) {
          // Only handle mouse clicks (not keyboard)
          if (e.pointerType === 'mouse' || e.pointerType === '' || e.type === 'click') {
            const parent = btn.parentNode;
            const isOpen = parent.classList.contains('open');
            const href = btn.getAttribute('data-href');
            if (isOpen && href) {
              
              // Check for Ctrl + Click (or Cmd + Click on Mac)
              if (e.ctrlKey || e.metaKey) {
                // Ctrl + Click: Open in new tab
                window.open(href, '_blank');
                
                // Close submenus but don't do AJAX navigation
                const backdrop = document.querySelector('.backdrop');
                if (backdrop) {
                  backdrop.classList.remove('active');
                }
                document.body.classList.remove('activeNav');
                
                // Hide all submenus
                const submenus = document.querySelectorAll('.hover-menu, .nav__brands');
                submenus.forEach(submenu => {
                  submenu.setAttribute('inert', '');
                  submenu.setAttribute('tabindex', '-1');
                  submenu.classList.remove('d-flex', 'show-md', 'flex-colum-xs','flex-column-sm','flex-row-md');
                  submenu.classList.add('nav-hidden');
                });
                
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              
              // Normal click: Allow AJAX to handle navigation
              // window.location.href = href; // Allow AJAX to handle navigation
            }
            // Prevent opening submenu on mouse click
            e.preventDefault();
            e.stopPropagation();
          }
        });
      });
    }

  }

  showMainNav(_self) {
      // Reset submenu disabled flag when mobile menu is opened
      _self.submenusDisabledByNavigation = false;
      
      for (let i = 0; i < _self.mainNav.length; ++i) {
          /* add active classes */
          _self.mainNav[i].classList.add("active")
          document.body.classList.add("modal_active")
      }
      /* add scrollpostion */
      _self.scrollPosition = window.pageYOffset
      document.body.style.overflow = "hidden"
      document.body.style.position = "fixed"
      document.body.style.top = `-${_self.scrollPosition}px`
      // Set focus to the first focusable menu item for accessibility
      // <<< MODIFIED SELECTOR to explicitly exclude close button >>>
      const firstMenuItem = _self.mainNav[0]?.querySelector('.menu__categories > li > a:not(.menu__categories--close), .menu__categories > li > button:not(.menu__categories--close)');
      if (firstMenuItem) {
        firstMenuItem.focus();
      }
  }

  hideMainNav(_self) {
      for (let i = 0; i < _self.mainNav.length; ++i) {
          /* remove active classes */

          _self.mainNav[i].classList.remove("active")
          document.body.classList.remove("modal_active")
      }
      /* remove scrollpostion */
      document.body.style.removeProperty("overflow")
      document.body.style.removeProperty("position")
      document.body.style.removeProperty("top")
      document.body.classList.remove("activeNav")
      document.querySelector(".backdrop").classList.remove('active')
      window.scrollTo(0, _self.scrollPosition)
  }

  setActiveLink(e, _self) {
      const parent = e.target.parentNode
      /* if children prevent link follow - level1 */
      e.preventDefault()
      /* show level - 1 if children */

      e.target.parentNode.classList.toggle("open")
      e.target.parentNode.parentNode.classList.toggle("open")
      /* scroll menu to top on click */
      _self.ScrolltoTop.scrollIntoView()
  }

  /* toggle back to level0 */
  setActiveBack(e, _self) {
    e.preventDefault(); // Prevent any default link behavior
    e.stopPropagation(); // Stop the event from bubbling up

    const backButton = e.target;
    // Find the immediate submenu containing the back button
    const submenu = backButton.closest('.hover-menu, .nav__brands');
    // Find the parent LI of that specific submenu
    const parentLi = submenu ? submenu.closest('li.has__children') : null;
    // Find the toggle button within that parent LI
    const toggleBtn = parentLi ? parentLi.querySelector('button.menuitem-toggle, button.submenu-toggle') : null;

    if (submenu && parentLi && toggleBtn) {
      // 1. Update classes: ONLY remove from the parent LI
      parentLi.classList.remove('open');
      // Remove submenu display classes (fix for back button)
      submenu.classList.remove('d-flex', 'show-md', 'flex-colum-xs', 'flex-column-sm', 'flex-row-md');
      submenu.classList.add('nav-hidden');
      // 2. Update ARIA attributes using the utility function
      toggleBtn.setAttribute('aria-expanded', 'false');
      // Assuming setMenuVisibility is defined in the scope
      if (typeof setMenuVisibility === 'function') {
         setMenuVisibility(submenu, false);
      } else {
         // Fallback if function not found (should not happen)
         submenu.setAttribute('inert', '');
         submenu.setAttribute('aria-hidden', 'true');
      }

      // 3. Remove focus trap
      if (submenu._removeTrap) {
        submenu._removeTrap();
      }

      // 4. Return focus to the toggle button
      requestAnimationFrame(() => {
        toggleBtn.focus();
      });

    } else {
      // Optional: Add fallback behavior here if needed, e.g., hide the whole menu?
      // For now, just log the error.
    }

    // Prevent scrolling to top
    // _self.ScrolltoTop.scrollIntoView(); // Already commented out
  }

  // Method to close menu on link click for desktop
  setupMenuLinkHandlers() {
    // Use event delegation with capture phase to intercept clicks before other handlers
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.hover-menu a[href], .nav__brands a[href], .menu__categories > li:not(.has__children) > a[href]');
      if (link && link.href && link.href !== '#' && link.href !== '') {
        this.handleLinkClick.call(this, e);
      }
    }, true); // Use capture phase to run before other handlers
  }

  // Handler for link clicks in desktop and mobile menu
  handleLinkClick(e) {
    const link = e.target;
    const href = link.getAttribute('href');
    
    // Only handle links that actually navigate somewhere
    if (href && href !== '#' && href !== '') {
      
      // Check for Ctrl + Click (or Cmd + Click on Mac)
      if (e.ctrlKey || e.metaKey) {
        // Ctrl + Click: Open in new tab, don't prevent default
        window.open(href, '_blank');
        
        // Close submenus but don't do AJAX navigation
        const backdrop = document.querySelector('.backdrop');
        const isDesktop = window.matchMedia("screen and (min-width: 65rem)").matches;
        
        if (isDesktop) {
          if (backdrop) {
            backdrop.classList.remove('active');
          }
          document.body.classList.remove('activeNav', 'modal_active'); // Remove both classes
          
          // Set flag to prevent hover from re-enabling submenus
          this.submenusDisabledByNavigation = true;
          this.submenusDisabledAt = Date.now();
          
          // Reset the flag after a delay to allow normal hover behavior later
          setTimeout(() => {
            this.submenusDisabledByNavigation = false;
          }, 5000); // 5 seconds delay
          
          // Hide all submenus
          const submenus = document.querySelectorAll('.hover-menu, .nav__brands');
          submenus.forEach(submenu => {
            submenu.setAttribute('inert', '');
            submenu.setAttribute('tabindex', '-1');
            submenu.classList.remove('d-flex', 'show-md', 'flex-colum-xs','flex-column-sm','flex-row-md');
            submenu.classList.add('nav-hidden');
          });
        } else {
          // Mobile menu closing
          this.hideMainNav(this);
        }
        
        // Don't prevent default - let the new tab open
        return;
      }
      
      // Normal click: Prevent default navigation so we can handle it via AJAX
      e.preventDefault();
      
      const backdrop = document.querySelector('.backdrop');
      const isDesktop = window.matchMedia("screen and (min-width: 65rem)").matches;
      
      if (isDesktop) {
        // Desktop menu closing - hide submenus after navigation
        if (backdrop) {
          backdrop.classList.remove('active');
        }
        document.body.classList.remove('activeNav', 'modal_active'); // Remove both classes
        
        // Set flag to prevent hover from re-enabling submenus
        this.submenusDisabledByNavigation = true;
        this.submenusDisabledAt = Date.now();
        
        // Reset the flag after a delay to allow normal hover behavior later
        setTimeout(() => {
          this.submenusDisabledByNavigation = false;
        }, 5000); // 5 seconds delay
        
        // Hide all submenus using nav-hidden class
        const submenus = document.querySelectorAll('.hover-menu, .nav__brands');
        submenus.forEach(submenu => {
          submenu.setAttribute('inert', '');
          submenu.setAttribute('tabindex', '-1');
          submenu.classList.remove('d-flex', 'show-md', 'flex-colum-xs','flex-column-sm','flex-row-md');
          submenu.classList.add('nav-hidden'); // Use nav-hidden instead of hide
          // Add inert back to all .global-category-items inside the submenu
          const globalCategoryItems = submenu.querySelectorAll('.global-category-items');
          globalCategoryItems.forEach(item => item.setAttribute('inert', ''));
        });
      } else {
        // Mobile menu closing
        this.hideMainNav(this);
      }
      
      // Use Ajaxify navigation to ensure scroll position is reset
      if (window.ajaxify && window.ajaxify.navigatePage) {
        // Determine page type based on URL pattern
        const pageType = href.includes('/product/') ? 'product' : 'list';
        window.ajaxify.navigatePage(href, pageType, null, link, { triggeredBy: 'menuNavigation' });
      } else {
        // Fallback to normal navigation if Ajaxify is not available
        window.location.href = href;
      }
    }
  }

  // Setup desktop hover logic with delay
  setupDesktopHoverLogic() {
    const target = document.querySelector('.menu__categories');
    const backdrop = document.querySelector('.backdrop');
    let navTimeoutId = null;
    const navDelay = 200; // Delay in milliseconds
    let currentOpenSubmenu = null; // Track the currently open submenu

    if (!target) return; // Exit if no menu found

    // Mouse tracking for debugging
    let lastMousePosition = { x: 0, y: 0 };
    let mouseTrackingEnabled = false;
    
    const trackMouse = (event) => {
      if (!mouseTrackingEnabled) return;
      
      const elementUnderMouse = document.elementFromPoint(event.clientX, event.clientY);
      const isOverSubmenu = elementUnderMouse && (
        elementUnderMouse.closest('.hover-menu') || 
        elementUnderMouse.closest('.nav__brands')
      );
      const isOverMenuItem = elementUnderMouse && elementUnderMouse.closest('.menu__categories > li');
      const isOverBackdrop = elementUnderMouse && elementUnderMouse.classList.contains('backdrop');
      
      if (window.debugConfig && window.debugConfig.isDebugEnabled('mainNavigation')) {
        console.log('🖱️ Mouse tracking', {
          x: event.clientX,
          y: event.clientY,
          elementUnderMouse: elementUnderMouse?.tagName + (elementUnderMouse?.className ? '.' + elementUnderMouse.className : ''),
          isOverSubmenu,
          isOverMenuItem,
          isOverBackdrop,
          currentOpenSubmenu: currentOpenSubmenu?.id
        });
      }
      
      lastMousePosition = { x: event.clientX, y: event.clientY };
    };
    
    // Enable mouse tracking when menu is active
    document.addEventListener('mousemove', trackMouse);

    // Opens the submenu for a menu item
    const openSubmenu = (menuItem) => {
      const targetSubmenu = menuItem.querySelector('.hover-menu, .nav__brands');
      
      if (window.debugConfig && window.debugConfig.isDebugEnabled('mainNavigation')) {
        console.log('🔄 openSubmenu called', {
          menuItem: menuItem.innerText?.trim().substring(0, 20),
          targetSubmenu: targetSubmenu?.id,
          currentOpenSubmenu: currentOpenSubmenu?.id,
          isSameSubmenu: currentOpenSubmenu === targetSubmenu
        });
      }
      
      // If this is the same submenu that's already open, do nothing
      if (currentOpenSubmenu === targetSubmenu) {
        if (window.debugConfig && window.debugConfig.isDebugEnabled('mainNavigation')) {
          console.log('⏭️ Same submenu already open, skipping');
        }
        return;
      }

      // Close the currently open submenu if it exists
      if (currentOpenSubmenu) {
        if (window.debugConfig && window.debugConfig.isDebugEnabled('mainNavigation')) {
          console.log('🔒 Closing current submenu', currentOpenSubmenu.id);
        }
        currentOpenSubmenu.setAttribute('inert', '');
        currentOpenSubmenu.setAttribute('tabindex', '-1');
        currentOpenSubmenu.classList.remove('d-flex', 'show-md', 'flex-colum-xs', 'flex-column-sm','flex-row-md');
        currentOpenSubmenu.classList.add('nav-hidden'); // Use nav-hidden instead of hide
      }

      document.body.classList.add('activeNav');
      if (backdrop) {
        backdrop.classList.add('active');
      }

      if (targetSubmenu) {
        if (window.debugConfig && window.debugConfig.isDebugEnabled('mainNavigation')) {
          console.log('🔓 Opening new submenu', targetSubmenu.id);
          mouseTrackingEnabled = true; // Enable mouse tracking when submenu opens
        }
        targetSubmenu.removeAttribute('inert');
        targetSubmenu.setAttribute('tabindex', '0');
        targetSubmenu.classList.add('d-flex', 'show-md', 'flex-colum-xs', 'flex-column-sm','flex-row-md');
        targetSubmenu.classList.remove('nav-hidden');
        currentOpenSubmenu = targetSubmenu;
        const globalCategoryItems = targetSubmenu.querySelectorAll('.global-category-items');
        globalCategoryItems.forEach(item => item.removeAttribute('inert'));
      }
    };

    // Handles pointer entering a top-level menu item
    const handleItemEnter = (event) => {
      if (navTimeoutId) {
        clearTimeout(navTimeoutId);
        navTimeoutId = null;
      }
      const menuItem = event.currentTarget;
      navTimeoutId = setTimeout(() => openSubmenu(menuItem), navDelay);
    };

    // Cancel pending submenu open if pointer leaves before delay
    const handleItemLeave = () => {
      if (navTimeoutId) {
        clearTimeout(navTimeoutId);
        navTimeoutId = null;
      }
    };

    // Mouse out handler for main menu
    const mOut = () => {
      // Clear any pending timeout to close the menu
      if (navTimeoutId) {
        clearTimeout(navTimeoutId);
        navTimeoutId = null;
      }

      // Start a timeout to delay closing the submenu
      navTimeoutId = setTimeout(() => {
        if (window.debugConfig && window.debugConfig.isDebugEnabled('mainNavigation')) {
          console.log('🔒 Closing submenu via timeout', {
            currentOpenSubmenu: currentOpenSubmenu?.id,
            hasActiveNav: document.body.classList.contains('activeNav')
          });
          mouseTrackingEnabled = false; // Disable mouse tracking when submenu closes
        }
        
        const clicked = document.querySelector('.reload');
        if (clicked) {
          clicked.classList.remove('reload');
        }
        if (backdrop) {
          backdrop.classList.remove('active');
        }
        document.body.classList.remove('activeNav');

        // Add inert attribute back to all submenus and set display to none
        const submenus = document.querySelectorAll('.hover-menu, .nav__brands');
        submenus.forEach(submenu => {
          submenu.setAttribute('inert', '');
          submenu.setAttribute('tabindex', '-1');
          submenu.classList.remove('d-flex', 'show-md', 'flex-colum-xs','flex-column-sm','flex-row-md');
          // Add inert back to all .global-category-items inside the submenu
          const globalCategoryItems = submenu.querySelectorAll('.global-category-items');
          globalCategoryItems.forEach(item => item.setAttribute('inert', ''));
        });
        
        currentOpenSubmenu = null; // Clear the reference
      }, navDelay); // Use the navDelay constant for the timeout duration
    };

    // Handler for mouse entering a submenu
    const handleSubmenuMouseOver = () => {
      if (window.debugConfig && window.debugConfig.isDebugEnabled('mainNavigation')) {
        console.log('🎯 Mouse entered submenu', {
          currentOpenSubmenu: currentOpenSubmenu?.id,
          timeoutCleared: !!navTimeoutId
        });
      }
      
      // Clear any pending timeout to close the menu
      if (navTimeoutId) {
        clearTimeout(navTimeoutId);
        navTimeoutId = null;
      }
    };

    // Handler for mouse leaving a submenu
    const handleSubmenuMouseOut = () => {
      // Start the timeout to close the menu again
      mOut();
    };

    // Attach event listeners
    const menuItems = target.querySelectorAll(':scope > li');
    menuItems.forEach(item => {
      item.addEventListener('mouseenter', handleItemEnter, false);
      item.addEventListener('mouseleave', handleItemLeave, false);
    });
    target.addEventListener('mouseleave', mOut, false);

    const submenus = document.querySelectorAll('.hover-menu, .nav__brands');
    submenus.forEach(submenu => {
      submenu.addEventListener('mouseover', handleSubmenuMouseOver, false);
      submenu.addEventListener('mouseout', handleSubmenuMouseOut, false);
    });
  }

}